import React, { useCallback, useEffect, useRef, useState } from "react";
import { Modal, ModalContent, Overlay } from "./styled";
import { useDispatch, useSelector } from "react-redux";
import {
  closeModal,
  getZIndex,
  selectIsOpen,
} from "../../redux/Slice/modalSlice";
import { AuthForm } from "./AuthForm/AuthForm";
import { modalState } from "../../utils/constants";
import { CSSTransition } from "react-transition-group";
import { CSS_TRANSITION_TIMEOUT } from "../Header/Header";
import useOnClickOutside from "../../hooks/useOnClickOutside";

const AuthModal = () => {
  const isOpen = useSelector(selectIsOpen(modalState.AUTH));
  const zIndex = useSelector(getZIndex);
  const ref = useRef();
  const dispatch = useDispatch();

  const originalOverflowRef = useRef(null);

  const [stepForm, setStepForm] = useState(0);

  const handleCloseButtonClick = useCallback(() => {
    dispatch(closeModal(modalState.AUTH));
  }, [dispatch]);

  const handleOutsideClick = useCallback(() => {
    if (stepForm === 0) {
      dispatch(closeModal(modalState.AUTH));
    }
  }, [dispatch, stepForm]);

  useOnClickOutside(ref, handleOutsideClick);

  useEffect(() => {
    const rootEl = document.getElementById("root");

    if (rootEl && isOpen) {
      originalOverflowRef.current = rootEl.style.overflowY;
      rootEl.style.overflowY = "hidden";
    }

    if (!isOpen) {
      setStepForm(0);
    }

    return () => {
      rootEl.style.overflowY = originalOverflowRef.current;
    };
  }, [isOpen]);

  return (
    <>
      <CSSTransition
        in={isOpen}
        timeout={CSS_TRANSITION_TIMEOUT}
        classNames="blackPage"
        unmountOnExit
      >
        <Overlay $zIndex={zIndex} />
      </CSSTransition>

      <CSSTransition
        in={isOpen}
        timeout={CSS_TRANSITION_TIMEOUT}
        classNames="alert"
        unmountOnExit
      >
        <Modal $zIndex={zIndex}>
          <ModalContent ref={ref}>
            <AuthForm
              handleCloseButtonClick={handleCloseButtonClick}
              setStepForm={setStepForm}
            />
          </ModalContent>
        </Modal>
      </CSSTransition>
    </>
  );
};

export default AuthModal;
